import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ClaimResponseType } from '../../redux/actions/types'
import { ItemInfo } from '../ItemInfo/ItemInfo'
import {
  createRuStatusValueForClaim,
  createStyleForStatusClaim,
} from '../../utils/createStatusForClaims'
import PATH from '../../navigation/path'
import styles from './OtherClaimCard.module.css'

interface OtherClaimCardProps {
  claim: ClaimResponseType
}

export const OtherClaimCard: React.FC<OtherClaimCardProps> = ({ claim }) => {
  const navigate = useNavigate()

  const startDate = claim.startDate
    ? claim.startDate.slice(0, 10).split('-').reverse().join('.')
    : ''
  const startTime = claim.startDate ? claim.startDate.slice(11, 16) : ''
  const endDate = claim.endDate ? claim.endDate.slice(0, 10).split('-').reverse().join('.') : ''
  const endTime = claim.endDate ? claim.endDate.slice(11, 16) : ''

  const handleNavigateToClaim = () => {
    navigate(`${PATH.claimCardPage}${claim.id}`)
  }

  return (
    <div className={styles.otherClaimBlock}>
      <div className={styles.otherClaimContainer}>
        <ItemInfo title='Зал' value={claim.place?.name || '-'} />
        <ItemInfo title='Город' value={claim.place?.city || '-'} />
        <ItemInfo
          title='Менеджер'
          value={claim?.manager?.fullName || claim?.user?.fullName || '-'}
        />
        <ItemInfo
          title='Дата и время начала'
          value={startDate && startTime ? `${startDate}, ${startTime}` : '-'}
        />
        <ItemInfo
          title='Дата и время окончания'
          value={endDate && endTime ? `${endDate}, ${endTime}` : '-'}
        />
        <ItemInfo title='Количество гостей' value={`${claim.peopleCount} человек(a)`} />
        <ItemInfo
          title='Статус'
          value={createRuStatusValueForClaim(claim.status)}
          classNameValue={createStyleForStatusClaim(claim.status)}
        />
        <div className={styles.claimLink}>
          <button onClick={handleNavigateToClaim} className={styles.linkButton}>
            Перейти к заявке
          </button>
        </div>
      </div>
    </div>
  )
}
